 <button mat-flat-button appRestricted [permissions]="permissions()" restrictionStrategy="hide" class="button--tertiary overview-header-add__button" (click)="onAddClick($event)">
		<ogs-m3-icon icon="plus" matButtonIcon/>
		<span>{{"Hinzufügen" | translate: "action-add" }}</span>
	</button>